/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Roll_Up_3Inputs */



/**
* | output |
* | --- |
* | "Roll-Up 3" |
*
* @param {Input_Caption_Style_Roll_Up_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_roll_up_3 = /** @type {((inputs?: Input_Caption_Style_Roll_Up_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Roll_Up_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déroulant 3")
	if (locale === "de") return /** @type {LocalizedString} */ ("Roll-Up 3")
	if (locale === "it") return /** @type {LocalizedString} */ ("Roll-Up 3")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Roll-Up 3")
	if (locale === "es") return /** @type {LocalizedString} */ ("Roll-Up 3")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Roll-Up 3")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロールアップ3")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रोल-अप 3")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enrole 3")
	return /** @type {LocalizedString} */ ("Roll-Up 3")
});